module.exports = __webpack_public_path__ + "static/media/maps-and-flags.7c9810df.svg";